import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/core/Menu";
import { Menu as MenuIcon } from "@material-ui/icons";

import scientificProgramLinks from "../ScientificProgramLinks";

import "./Header.css";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      communityEl: null,
      facultyEl: null,
      displayRoute: props.displayRoute,
      scrolled: false,
    };
    this.routes = [
      {
        name: "Home",
        link: "/",
      },
      {
        name: "Committee",
        link: "/committee",
      },
      {
        name: "Scientific Program",
        link: "/scientific-program",
      },
      {
        name: "Near by Places",
        link: "/nearby-places",
      },
      {
        name: "Accommodation",
        link: "/accomodation",
      },
      {
        name: "Visa",
        link: "/visa",
      },
      {
        name: "Sponsorship",
        link: "/sponsorship",
      },
      {
        name: "Contact",
        link: "/contact",
      },
    ];

    this.academicSection = [
      {
        name: "",
        link: "/academic-section",
      },
    ];

    this.eventCommittee = [
      {
        name: "Patron",
        link: "/patrons",
      },
      {
        name: "Co-Patrons",
        link: "/co-patrons",
      },
      {
        name: "Organizing Committee",
        link: "/organizing-committee",
      },
      {
        name: "Treasurer",
        link: "/treasurer",
      },
      {
        name: "Scientific Committee Members",
        link: "/scientific-commitee-members",
      },
      {
        name: "E-Souvenir Committee Members",
        link: "/e-souvenir-committee-members",
      },
      {
        name: "Registration& Sponsorship Committee",
        link: "/registration-and-sponsorship-committee",
      },
      {
        name: "Hospitality & Transport Committee",
        link: "/hospitality-and-transport-committee",
      },
      {
        name: "Stage & Venue Management Committee",
        link: "/stage-and-venue-management-committee",
      },
      {
        name: "International Advisory Board",
        link: "/international-advisory-board",
      },
      {
        name: "National Advisory Board",
        link: "/national-advisory-board",
      },
      {
        name: "Regional Advisory Board",
        link: "/regional-advisory-board",
      },
    ];

    this.SocaCommittee = [
      {
        name: "Office Bearers",
        link: "/office-bearers",
      },
      {
        name: "Executive Committee Members",
        link: "/executive-committee-members",
      },
    ];

    this.csiCommittee = [
      {
        name: "CSI UP Chapter",
        link: "/csi-up-chapter",
      },
      {
        name: "National CSI Office Bearers",
        link: "/national-csi-office-bearers",
      },
    ];

    this.scientificProgram = scientificProgramLinks;
  }

  handleScroll = () => {
    const scrollY = this.scrollContainer === window ? window.scrollY : this.scrollContainer.scrollTop;
    const scrolled = scrollY > 60;
    if (scrolled !== this.state.scrolled) {
      this.setState({ scrolled });
    }
  };

  componentDidMount() {
    this.scrollContainer = document.querySelector(".screen-container") || window;
    this.scrollContainer.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener("scroll", this.handleScroll);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.setState({ drawerOpen: false });
    }
    if (this.props.match.params.name !== prevProps.match.params.name) {
      this.setState({ communityEl: null, open: false });
    }
  }

  handleOpen = (event, type) => {
    if (type === "community") {
      this.setState({ communityEl: event.currentTarget, open: true });
    } else {
      this.setState({ facultyEl: event.currentTarget, open: true });
    }
  };

  handleClose = () => {
    this.setState({ communityEl: null, facultyEl: null, open: false });
  };

  navigateTo = (route) => {
    if (route === "/contact") {
      const footer = document.getElementById("footer");
      if (footer) footer.scrollIntoView({ behavior: "smooth" });
    } else {
      this.props.history.push(route);
    }
    this.toggleDrawer(false);
    this.handleClose();
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    this.setState({ drawerOpen: false });
  };

  render() {
    const pathname = this.props.history.location.pathname;
    const isTransparentPage = pathname === "/" || pathname.startsWith("/committee");
    const headerClass = isTransparentPage ? `header${this.state.scrolled ? " scrolled" : ""}` : "header solid";

    return (
      <header className={headerClass}>
        <div className="nav-row-2">
          <div className="nav-wrapper">
            <div className="nav-left" onClick={() => this.navigateTo("/")}>
              <img src="/socacon-27.png" alt="SOCA" className="banner-soca-logo" />
              <div className="banner-info-block">
                {/* <p className="banner-conf-title">
                  15th International Conference
                  <br />
                  of the Society of Clinical Anatomists
                </p> */}
                <p className="banner-conf-meta">
                  Organised by Department of Anatomy &amp; IQAC
                  <br />
                  Dr. RMLIMS, Lucknow(U.P.) India.
                </p>
              </div>
            </div>
            <nav className="nav-links">
              <div className="nav-center">
                {this.routes.map((route, index) => {
                  if (route.name === "Committee") {
                    return (
                      <React.Fragment key={index}>
                        <Button className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                          Committee
                        </Button>
                        <Menu
                          anchorEl={this.state.communityEl}
                          open={this.state.open && this.state.communityEl !== null}
                          onClose={this.handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}>
                          <div className="committee-dropdown">
                            <div className="committee-header">
                              <h4 className="dropdown-header">Event Committee</h4>
                              <h4 className="dropdown-header">SOCA Executives</h4>
                            </div>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                {this.eventCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>

                              <div className="committee-divider" />

                              <div className="committee-subsection">
                                {this.SocaCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Menu>
                      </React.Fragment>
                    );
                  }
                  if (route.name === "Scientific Program") {
                    return (
                      <React.Fragment key={index}>
                        <Button className="link-btn" onClick={(e) => this.handleOpen(e, "faculty")}>
                          Scientific Program
                        </Button>
                        <Menu
                          anchorEl={this.state.facultyEl}
                          open={this.state.open && this.state.facultyEl !== null}
                          onClose={this.handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}>
                          <div className="committee-dropdown">
                            <div className="committee-header">
                              <h4 className="dropdown-header">Scientific Program</h4>
                            </div>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                {this.scientificProgram.map((item, i) => (
                                  <Button key={i} className="menu-link-btn" onClick={() => this.navigateTo(item.link)}>
                                    {item.name}
                                  </Button>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Menu>
                      </React.Fragment>
                    );
                  }
                  return (
                    <Button
                      key={index}
                      className={`link-btn ${route.name === "Abstract" ? "abstract-btn" : ""}`}
                      onClick={() => this.navigateTo(route.link)}>
                      {route.name}
                    </Button>
                  );
                })}
                <a href="/socacon2027-brochure.pdf" target="_blank" rel="noreferrer noopener" className="desktop-only">
                  <Button className={`link-btn`}>Brochure</Button>
                </a>
              </div>
              <Button
                className="nav-link-btn receipt-btn"
                color="primary"
                variant="outlined"
                onClick={() => this.navigateTo("/get-receipt")}>
                Receipt
              </Button>
              <Button
                className="nav-link-btn abstract-btn"
                color="primary"
                variant="outlined"
                onClick={() => this.navigateTo("/registration")}>
                Register Now
              </Button>
            </nav>

            <div className="header-menu-bar">
              <MenuIcon fontSize="large" onClick={() => this.toggleDrawer(true)} />
            </div>

            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <div
                    className="drawer-header-block"
                    onClick={() => this.navigateTo("/")}
                    style={{ cursor: "pointer", padding: "10px 20px", display: "flex", alignItems: "center", gap: "15px" }}>
                    <img src="/socacon-27.png" alt="logo" className="drawer-logo" style={{ margin: 0 }} />
                    <div className="banner-info-block mobile-banner-info">
                      {/* <p className="banner-conf-title" style={{ fontSize: '14px' }}>
                        15th International Conference
                        <br />
                        of the Society of Clinical Anatomists
                      </p> */}
                      <p className="banner-conf-meta" style={{ fontSize: "12px", marginTop: "5px" }}>
                        Organised by Department of Anatomy &amp; IQAC
                        <br />
                        Dr. RMLIMS, Lucknow(U.P.) India.
                      </p>
                    </div>
                  </div>

                  {this.routes.map((route, index) => {
                    if (route.name === "Committee") {
                      return (
                        <React.Fragment key={index}>
                          <Button key={index} className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                            Committee
                          </Button>
                          <Menu
                            anchorEl={this.state.communityEl}
                            open={this.state.open && this.state.communityEl !== null}
                            onClose={this.handleClose}>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">Event Committee</h4>
                                {this.eventCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">SOCA Executives</h4>
                                {this.SocaCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                            </div>
                          </Menu>
                        </React.Fragment>
                      );
                    }
                    if (route.name === "Scientific Program") {
                      return (
                        <React.Fragment key={index}>
                          <Button className="link-btn" onClick={(e) => this.handleOpen(e, "faculty")}>
                            Scientific Program
                          </Button>
                          <Menu
                            anchorEl={this.state.facultyEl}
                            open={this.state.open && this.state.facultyEl !== null}
                            onClose={this.handleClose}>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">Scientific Program</h4>
                                {this.scientificProgram.map((item, i) => (
                                  <Button key={i} className="menu-link-btn" onClick={() => this.navigateTo(item.link)}>
                                    {item.name}
                                  </Button>
                                ))}
                              </div>
                            </div>
                          </Menu>
                        </React.Fragment>
                      );
                    }
                    return (
                      <Button
                        key={index}
                        className={`link-btn ${route.name === "Abstract" ? "abstract-btn" : ""}`}
                        onClick={() => this.navigateTo(route.link)}>
                        {route.name}
                      </Button>
                    );
                  })}
                  <a href="/socacon2027-brochure.pdf" target="_blank" rel="noreferrer noopener">
                    <Button className={`link-btn`}>Brochure</Button>
                  </a>

                  <Button
                    className="nav-link-btn receipt-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.navigateTo("/get-receipt")}>
                    Receipt
                  </Button>

                  <Button
                    className="nav-link-btn abstract-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.navigateTo("/registration")}>
                    Register Now
                  </Button>
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}
